
theme.RecentlyViewed = (function () {
  var selectors = {
  }

  var init = false

  function RecentlyViewed(container) {
    this.container = container
    this.sectionId = this.container.getAttribute('data-section-id')
    this.namespace = '.recently-viewed' + this.sectionId
    theme.initWhenVisible({
      element: this.container,
      callback: this.init.bind(this),
      threshold: 600,
    })
  }

  RecentlyViewed.prototype = Object.assign({}, RecentlyViewed.prototype, {
    init: function () {
      if (init) {
        return
      }
      this.recentlyClass = '.recently-viewed-products'

      init = true
      if (
        theme.recentlyViewed.recent.viewed.length === 0 &&
        theme.recentlyViewed.recent.constructor === Object
      ) {

        if (window.location.pathname.startsWith('/pages/welcome-back')) {
          return $(this.recentlyClass).closest('.shopify-section').hide()
          // .closest('.page-section').css({ paddingTop: 0 });
        }

        // No previous history on page load, so bail
        return
      }

      if (window.location.pathname.startsWith('/pages/welcome-back')) {
        $(this.recentlyClass).closest('.page-section')[0].style = {}
        $(this.recentlyClass).closest('.page-section').find('.vego-tab-title').removeClass('hide')
      }


      this.outputContainer = document.getElementById(
        'RecentlyViewed-' + this.sectionId
      )
      this.handle = this.container.getAttribute('data-product-handle')
      this.count = parseInt(this.container.getAttribute('data-recent-count'))

      // Request new product info via JS API
      var promises = [], that = this;
      let num = 0;
      theme.recentlyViewed.recent.viewed.forEach(
        function (handle) {
          if (handle !== 'undefined' && handle !== 'test-product') {
            if (num > that.count) return;
            num++;
            //memorial-day recently view
            if (window.location.pathname.startsWith('/pages/welcome-back')) {
              promises.push(this.getProductInfoInMemorialDayaPage(handle))
            } else {
              promises.push(this.getProductInfo(handle))
            }
          }
        }.bind(this)
      )

      Promise.all(promises).then(
        function (result) {
          //memorial-day recently view
          if (window.location.pathname === ('/pages/welcome-back')) {

            if (result.length === 0) {
              // no result data
              $(this.recentlyClass).closest('.vego-tab-content').hide()
                .closest('.page-section').css({ paddingTop: 0 });
              return;
            }
            this.renderRecentlyViewed(result)


          } else {
            if (!theme.templates['template-recent'].result) {
              theme.loadTemplate('template-recent').then(res => {
                theme.templates['template-recent'].result = res
                this.setupOutput(result)
                this.captureProductDetails(result)
              })
            } else {
              this.setupOutput(result)
              this.captureProductDetails(result)
            }
          }
        }.bind(this)
      )
    },
    pureStyle(index, $item) {
      const recentlyClass = '.recently-viewed-products'
      if (index === 0) {
        $item.find('style').insertBefore(recentlyClass)
      } else {
        $item.find('style').remove()
      }
    },
    renderRecentlyViewed: function (result) {
      const recentlyClass = this.recentlyClass;
      const $container = $(recentlyClass);
      if ($container.length) {
        const $wrapper = $container.find('.swiper-wrapper');
        const $target = $wrapper.length ? $wrapper : $container;
        $target.html('')

        result.forEach((item, index) => {
          let $item = $(item);
          this.pureStyle(index, $item)
          let $slide = $('<div class="swiper-slide"></div>');
          $slide.append($item.html())
          $target.append($slide)
        })

        try {
          const hostEl = $container.closest('swiper-carousel')[0];
          if (hostEl) {
            if (typeof hostEl.destroySwiper === 'function') hostEl.destroySwiper()
            if (typeof hostEl.init === 'function') hostEl.init()
          }
          AOS.refreshHard()
        } catch (e) {
          console.log(e)
        }
        if (theme.settings.cartType === 'drawer') {
          try {
            $.$$updateInput()
            $(`${recentlyClass} select.grid-product-variant-input:enabled`).vselect()
            $(`${recentlyClass} [data-ui="select"]`).vselect()
            $('[data-toggle="tooltip"]').tooltip()
          } catch (e) {
            console.log(e)
          }
          $(`${recentlyClass} .grid-product`).collecionProduct()
        }
      }
    },
    getProductInfoInMemorialDayaPage: function (handle) {

      const recentlyViewedSection = `recently-viewed-product`;

      return new Promise(function (resolve, reject) {

        $.get(
          `${window.route_prefix}products/${handle}?sections=${recentlyViewedSection}`,
          function (data) {
            resolve(data[recentlyViewedSection]);
          }
        );

      })
    },

    getProductInfo: function (handle) {
      return new Promise(function (resolve, reject) {
        if (theme.recentlyViewed.productInfo.hasOwnProperty(handle)) {
          resolve(theme.recentlyViewed.productInfo[handle])
        } else {
          fetch(`${window.route_prefix}products/` + handle + ".js")
            .then(function (response) {
              return response.text();
            })
            .then(function (product) {
              resolve(product);
            });
        }
      })
    },

    setupOutput: function (products) {
      var allProducts = []
      var data = {}
      var limit = this.container.getAttribute('data-recent-count')
      var i = 0
      products.forEach(
        function (p) {
          if (!p) return
          var product = JSON.parse(p)
          // Ignore current product
          if (product.handle === this.handle) {
            return
          }
          // Ignore undefined key
          if (typeof product.handle == 'undefined') {
            return
          }
          i++
          // New or formatted properties
          product.url_formatted = theme.recentlyViewed.recent.products[product.handle]
            ? theme.recentlyViewed.recent.products[product.handle].url
            : product.url
          product.image_responsive_url = theme.Images.srcSetImages(product.featured_image)
          product.image_aspect_ratio =
            theme.recentlyViewed.recent.products[product.handle].aspectRatio
          let p_compare_at_price = product.compare_at_price;
            var firstVariant = product.variants[0]
          if (location.pathname.indexOf('/en-ca')>-1){
            if (!!theme.config.discountInfo[firstVariant.id].caCompareAtPrice)
              p_compare_at_price = theme.config.discountInfo[firstVariant.id].caCompareAtPrice;
          }else if (location.pathname.indexOf('/en-au')>-1){
            if (!!theme.config.discountInfo[firstVariant.id]?.auCompareAtPrice)
              p_compare_at_price =
                theme.config.discountInfo[firstVariant.id].auCompareAtPrice;
          }
            product.on_sale = p_compare_at_price > product.price;
          product.sold_out = !product.available

          product.price_formatted = theme.Currency.formatMoney(
            product.price,
            theme.settings.moneyFormat
          )
          product.compare_at_price_formatted = theme.Currency.formatMoney(
            p_compare_at_price,
            theme.settings.moneyFormat
          );
          product.price_min_formatted = theme.Currency.formatMoney(
            product.price_min,
            theme.settings.moneyFormat
          )
          product.money_saved = theme.Currency.formatMoney(
            p_compare_at_price - product.price,
            theme.settings.moneyFormat
          );
          if (product.tags.indexOf('Notify Me') > -1) {
            product.notify = true
          }

          // Unit pricing checks first variant
        
          if (theme.config.discountInfo && theme.config.discountInfo[firstVariant.id]) {
            var discount = theme.config.discountInfo[firstVariant.id]
            if (discount.discounted && p_compare_at_price > product.price) {
              var savedAmount = p_compare_at_price - product.price;
              var savedPercent = Math.round(
                ((p_compare_at_price - product.price) * 100) /
                  p_compare_at_price
              );
              var discountText = "";
              if (discount.percent || savedPercent >= savedAmount / 100) {
                discountText = savedPercent + "% OFF";
              } else {
                discountText =
                  "SAVE " +
                  theme.Currency.formatMoney(
                    savedAmount,
                    "${{amount_no_decimals}}"
                  );
              }
              product.discountText = discountText;
            }
          }
          // if (firstVariant && firstVariant.unit_price) {
          //   var baseUnit = ''

          allProducts.push(product)
        }.bind(this)
      )

      data = {
        items: allProducts.slice(0, limit),
        grid_item_width: this.container.getAttribute('data-grid-item-class'),
      }

      if (allProducts.length === 0) {
        return
      }

      this.outputContainer.innerHTML = theme.templates['template-recent'].result(data)
      window.yotpoWidgetsContainer && window.yotpoWidgetsContainer.initWidgets()

      if (AOS) {
        AOS.refreshHard()
      }
    },

    captureProductDetails: function (products) {
      for (var i = 0; i < products.length; i++) {
        var product = products[i]
        theme.recentlyViewed.productInfo[product.handle] = product
      }

      // Add data to session storage to reduce API requests later
      if (theme.config.hasSessionStorage) {
        sessionStorage.setItem(
          'recent-products',
          JSON.stringify(theme.recentlyViewed.productInfo)
        )
      }
    },

    onUnload: function () {
      init = false
    },
  })

  return RecentlyViewed
})()


theme.recentlyViewed.productInfo && (theme.recentlyViewed.productInfo =
  theme.config.hasSessionStorage && sessionStorage['recent-products']
    ? JSON.parse(sessionStorage['recent-products'])
    : {})
theme.sections.register('recently-viewed', theme.RecentlyViewed)